import { SELECT_AREA, SELECT_TOOL_DRAWING_AREA, UPDATE_DRAWING_AREA, END_DRAWING_AREA, BEGIN_DRAGGING_AREA, UPDATE_DRAGGING_AREA, END_DRAGGING_AREA } from '../constants';

export function selectArea(layerID, areaID) {
  return {
    type: SELECT_AREA,
    layerID: layerID,
    areaID: areaID
  };
}

export function selectToolDrawingArea(sceneComponentType) {
  return {
    type: SELECT_TOOL_DRAWING_AREA,
    sceneComponentType: sceneComponentType
  };
}

export function updateDrawingArea(layerID, x, y) {
  return {
    type: UPDATE_DRAWING_AREA,
    layerID: layerID, x: x, y: y
  };
}

export function endDrawingArea(layerID, x, y) {
  return {
    type: END_DRAWING_AREA,
    layerID: layerID, x: x, y: y
  };
}

export function beginDraggingArea(layerID, areaID, x, y) {
  return {
    type: BEGIN_DRAGGING_AREA,
    layerID: layerID, areaID: areaID, x: x, y: y
  };
}

export function updateDraggingArea(x, y) {
  return {
    type: UPDATE_DRAGGING_AREA,
    x: x, y: y
  };
}

export function endDraggingArea(layerID, areaID, x, y) {
  return {
    type: END_DRAGGING_AREA,
    layerID: layerID, areaID: areaID, x: x, y: y
  };
}